const pre = '/report/';

export default {
    path: '/report',
    title: '报备信息管理',
    header: 'home',
    custom: 'i-icon-demo i-icon-demo-dashboard',
    children: [
        {
            path: `${pre}report`,
            title: '报备信息管理'
        }

    ]
}
